module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_5.780a0b67.jpg";